import api from './api';

class AmenitiesService {
  async getList() {
    try {
      return await api.get('/amenities/group/list');
    } catch (error) {
      console.error('Error fetching list:', error);
      throw error;
    }
  }

  async getItemByList(id) {
    try {
      return await api.get(`/amenities/item/list/${id}`);
    } catch (error) {
      console.error('Error fetching item by list:', error);
      throw error;
    }
  }

  async create(data) {
    try {
      return await api.post('/amenities/item/create', data);
    } catch (error) {
      console.error('Error creating item:', error);
      throw error;
    }
  }

  async getDataPage(params) {
    try {
      return await api.get('/amenities/item/index', { params: params });
    } catch (error) {
      console.error('Error fetching data page:', error);
      throw error;
    }
  }

  async changeStatus(data) {
    try {
      return await this.create(data);
    } catch (error) {
      console.error('Error changing status:', error);
      throw error;
    }
  }
}

export default new AmenitiesService();
